import {
  SearchOutlined,
  SaveOutlined,
  ShareAltOutlined,
  DownloadOutlined,
  CopyOutlined,
  FilterOutlined,
  LineChartOutlined,
  QuestionCircleOutlined,
  FileTextOutlined,
  ClockCircleOutlined,
  SwapOutlined,
  PushpinOutlined,
  PieChartOutlined,
} from '@ant-design/icons';

// Map backend icon names to Ant Design icon components
export const ACTION_ICONS: Record<string, React.ComponentType<any>> = {
  search: SearchOutlined,
  save: SaveOutlined,
  share: ShareAltOutlined,
  download: DownloadOutlined,
  copy: CopyOutlined,
  filter: FilterOutlined,
  chart: LineChartOutlined,
  question: QuestionCircleOutlined,
  report: FileTextOutlined,
  time: ClockCircleOutlined,
  compare: SwapOutlined,
  pin: PushpinOutlined,
  pieChart: PieChartOutlined,
};

// Fallback icon for unmapped icons
export const getFallbackIcon = () => QuestionCircleOutlined;

// Get icon component by name with fallback
export const getActionIcon = (iconName: string): React.ComponentType<any> => {
  return ACTION_ICONS[iconName] || getFallbackIcon();
};
